// AI-CONTEXT: See docs/features/impact-in-beeld-hub.md

/** Statuses an ImpactChannels doc can carry ('off' = no doc, channel not enabled). */
const CHANNEL_STATUSES = ['concept', 'live', 'action-needed']

/**
 * @typedef {object} ImpactChannelDoc
 * @property {string} ChannelId - channel id from impactInBeeldConfig
 * @property {string} Status - 'concept' | 'live' | 'action-needed'
 */

/**
 * Status of one channel, derived from its ImpactChannels doc.
 *
 * @param {ImpactChannelDoc|null|undefined} channelDoc - the doc for this channel, if any
 * @returns {string} 'off' | 'concept' | 'live' | 'action-needed'
 */
const deriveChannelStatus = (channelDoc) => {
  if (!channelDoc || !CHANNEL_STATUSES.includes(channelDoc.Status)) return 'off'

  return channelDoc.Status
}

/**
 * @typedef {object} TodoItem
 * @property {string} channelId - channel id from impactInBeeldConfig
 * @property {string} title - channel title shown to the user
 * @property {string} reason - 'concept' (not yet published) | 'action-needed' (outdated)
 */

/**
 * "Nog te doen" list for the Overzicht tab: channels sitting in concept or
 * flagged action-needed, in channel-config order.
 *
 * @param {Array<{id: string, title: string}>|null} channels - channel config entries
 * @param {ImpactChannelDoc[]|null} channelDocs - ImpactChannels docs for this tenant
 * @returns {TodoItem[]} to-do items (empty when nothing needs attention)
 */
const buildTodoList = (channels, channelDocs) => {
  if (!Array.isArray(channels) || !Array.isArray(channelDocs)) return []

  return channels
    .map((channel) => {
      const doc = channelDocs.find((candidate) => candidate.ChannelId === channel.id)
      const status = deriveChannelStatus(doc)

      if (status !== 'concept' && status !== 'action-needed') return null

      return { channelId: channel.id, title: channel.title, reason: status }
    })
    .filter(Boolean)
}

export { CHANNEL_STATUSES, deriveChannelStatus, buildTodoList }
